if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"weborders","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(3155|5898|6547|7938|8826)$/.test(chunkId)},
		rootOutputDir: "../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}